import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import Dropdown from '../../components/Dropdown/Dropdown';
import Header from '../../components/Header/Header';
import { Category, Sidebar } from '../../components/Sidebar/Sidebar';
import { TaxAdvisorRoutesEnum } from '../../core/enums';
import { ReactComponent as DATEVIcon } from '../../icons/datev.svg';
import { ReactComponent as ProformaIcon } from '../../icons/proforma.svg';
import { ReactComponent as InvoiceBookIcon } from '../../icons/invoice-book.svg';
import { ReactComponent as ProfileIcon } from '../../icons/profile.svg';
import { ReactComponent as ArrowsIcon } from '../../icons/arrows.svg';
import { COMPANIES, useTaxAdvisor } from './tax-advisor-context';

export default function TaxAdvisorLayout({ children }: PropsWithChildren<{}>) {
  const { t } = useTranslation();

  const { company, onCompanyClick } = useTaxAdvisor();
  const location = useLocation();
  const isDatevConfiguration = location.pathname.startsWith(
    TaxAdvisorRoutesEnum.DATEVConfiguration
  );

  const categories: Category[] = [
    {
      name: 'Documents',
      links: [
        {
          label: 'DATEV',
          icon: <DATEVIcon />,
          to: TaxAdvisorRoutesEnum.DATEV,
        },
        {
          label: 'Pro-Forma',
          icon: <ProformaIcon />,
          to: TaxAdvisorRoutesEnum.Proforma,
        },
        {
          label: 'Invoice Book',
          icon: <InvoiceBookIcon />,
          to: TaxAdvisorRoutesEnum.InvoiceBook,
        },
      ],
    },
  ];

  return (
    <div className='d-flex'>
      {!isDatevConfiguration && (
        <Sidebar
          categories={categories}
          header={
            <div>
              <div className='fw-bold text-truncate mb-2'>
                John Doe Advisory
              </div>
              <div className='pt-2'>
                <Dropdown
                  horizontalAlignment='left'
                  className={`AggregatorDropdown mb-3 mx-n2`}
                  trigger={
                    <>
                      <span className='text-truncate text-start flex-grow-1 pe-1 fw-600'>
                        {company?.name}
                      </span>
                      <ArrowsIcon className='flex-shrink-0' />
                    </>
                  }
                  content={
                    <>
                      {COMPANIES.map((c) => (
                        <button
                          className={classNames(
                            'd-block px-3 py-2 AggregatorDropdown__menuItem w-100 text-start',
                            {
                              'AggregatorDropdown__menuItem--active':
                                c.company_id === company?.company_id,
                            }
                          )}
                          key={c.company_id}
                          onClick={onCompanyClick(c.company_id)}
                        >
                          {c.name}
                        </button>
                      ))}
                    </>
                  }
                />
              </div>
              <NavLink
                to='/'
                className='Sidebar__link text-decoration-none d-flex align-items-center mx-n2 mb-2 py-1 ps-2 mb-3'
                exact
              >
                <ProfileIcon />
                <span className='ms-1'>{t('Client account')}</span>
              </NavLink>
            </div>
          }
        />
      )}

      <div className='flex-grow-1'>
        <div className='d-flex flex-column'>
          <div className='min-vh-100 d-flex flex-column'>
            <Header
              logo={false}
              backBtn={isDatevConfiguration}
              label={isDatevConfiguration ? company?.name : undefined}
              backBtnPath={
                isDatevConfiguration ? TaxAdvisorRoutesEnum.DATEV : undefined
              }
            />
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
